module.exports = __webpack_public_path__ + "static/media/add_circle_gray.38c49271.svg";